module.exports = __webpack_public_path__ + "images/Ed_Sheeran_-_No._6_Collaborations_Project.png";